import React from 'react';
import { FaFacebook, FaInstagram, FaWhatsapp, FaEnvelope, FaPhone, FaMapMarkerAlt, FaTiktok } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-jungle-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 gap-x-6 gap-y-10 md:grid-cols-4 md:gap-x-8">
          {/* Columna 1: Sobre Nosotros (Ocupa todo el ancho en móvil) */}
          <div className="col-span-2 text-center md:col-span-1 md:text-left">
            <h3 className="text-2xl font-serif font-bold mb-4">Sumaq Mayu</h3>
            <p className="text-gray-300 mb-4 max-w-sm mx-auto md:mx-0">
              Un refugio en el corazón de la selva, donde la naturaleza y el confort se encuentran.
            </p>
            <div className="flex space-x-4 justify-center md:justify-start">
              <a href="https://www.facebook.com/profile.php?id=61578949205911" target="_blank" rel="noopener noreferrer" className="hover:text-jungle-400 transition-colors">
                <FaFacebook size={24} />
              </a>
              <a href="https://www.instagram.com/sumaqmayu/" target="_blank" rel="noopener noreferrer" className="hover:text-jungle-400 transition-colors">
                <FaInstagram size={24} />
              </a>
              <a href="https://wa.me/51947791970" target="_blank" rel="noopener noreferrer" className="hover:text-jungle-400 transition-colors">
                <FaWhatsapp size={24} />
              </a>
              <a href="https://www.tiktok.com/@sumaqmayu8?_r=1&_t=ZS-93YLmyF5Frx" target="_blank" rel="noopener noreferrer" className="hover:text-jungle-400 transition-colors">
                <FaTiktok size={24} />
              </a>
            </div>
          </div>

          {/* Columna 2: Enlaces Rápidos */}
          <div className="col-span-1 text-center md:text-left">
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li><a href="/#inicio" className="text-gray-300 hover:text-jungle-400 transition-colors">Inicio</a></li>
              <li><a href="/#habitaciones" className="text-gray-300 hover:text-jungle-400 transition-colors">Habitaciones</a></li>
              <li><a href="/#experiencias" className="text-gray-300 hover:text-jungle-400 transition-colors">Experiencias</a></li>
              <li><a href="/#contacto" className="text-gray-300 hover:text-jungle-400 transition-colors">Contacto y Ubicación</a></li>
            </ul>
          </div>

          {/* Columna 3: Información */}
          <div className="col-span-1 text-center md:text-left">
            <h4 className="text-lg font-semibold mb-4">Información</h4>
            <ul className="space-y-2">
              <li><a href="/terminos-y-condiciones" className="text-gray-300 hover:text-jungle-400 transition-colors">Términos y Condiciones</a></li>
              <li><a href="/preguntas-frecuentes" className="text-gray-300 hover:text-jungle-400 transition-colors">Preguntas Frecuentes</a></li>
              <li><a href="/sostenibilidad" className="text-gray-300 hover:text-jungle-400 transition-colors">Sostenibilidad</a></li>
            </ul>
          </div>

          {/* Columna 4: Contacto (Ocupa todo el ancho en móvil) */}
          <div className="col-span-2 text-center md:col-span-1 md:text-left">
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3 inline-block text-left">
              <li className="flex items-start">
                <FaMapMarkerAlt className="mt-1 mr-3 flex-shrink-0 text-jungle-400" />
                <span className="text-gray-300">
                  Carr. a Sta. Rosa, Tarapoto 22200
                </span>
              </li>
              <li className="flex items-center">
                <FaPhone className="mr-3 flex-shrink-0 text-jungle-400" />
                <div className="flex flex-col">
                  <a href="tel:+51947791970" className="text-gray-300 hover:text-jungle-400 transition-colors">+51 947 791 970</a>
                </div>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="mr-3 flex-shrink-0 text-jungle-400" />
                <a href="mailto:sumaqmayu@gmail.com" className="text-gray-300 hover:text-jungle-400 transition-colors">
                  sumaqmayu@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-jungle-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Sumaq Mayu. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
